import $ from 'jquery';

// var IS_DEVELOPMENT = false;
var win = $(window);
var body = $('body');

function InnerZoom(el, zoomX = 1.5) {
  this.elems = {};
  this.elems.container = $(el);
  this.elems.zoomer = null;

  this.zoomX = zoomX;

  this.coords = {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    zoomWidth: 0,
    zoomHeight: 0,
  };

  this.loadImage();
  this.bind();
}

var zoomerTemplate = '<div class="inner-zoom"><div class="inner-zoom-img" style="background-image:url(\':img\');"></div></div>';

InnerZoom.prototype.getImgSrc = function getImgSrc() {
  return this.elems.container.attr('data-inner-zoom');
};

InnerZoom.prototype.loadImage = function loadImage() {
  // TODO: Pre-carregar imagem
  this.elems.zoomer = $(zoomerTemplate.replace(':img', this.getImgSrc()));
  body.append(this.elems.zoomer);
  this.elems.zoomer.css({
    'background-color': '#fff',
    'transition': 'all .3s ease-out',
  }).hide();
};

InnerZoom.prototype.updateCoords = function updateCoords() {
  this.coords.width = this.elems.container.width();
  this.coords.height = this.elems.container.height();
  this.coords.zoomWidth = this.coords.width * this.zoomX;
  this.coords.zoomHeight = this.coords.height * this.zoomX;
  let os = this.elems.container.offset();
  this.coords.left = os.left;
  this.coords.top = os.top;
};

InnerZoom.prototype.bind = function bind() {
  let isHover = false;
  let isTapped = false;
  
  let eZoomer = this.elems.zoomer;
  let eImg = eZoomer.find('.inner-zoom-img');

  // @ START OVER
  let zoomOutDelay = 200;
  let zoomOutTimeout = null;

  let showZoomer = () => {
    // eImg.width(this.coords.zoomWidth);
    // eImg.height(this.coords.zoomHeight);
    eImg.css({
      width: this.coords.zoomWidth,
      height: this.coords.zoomHeight,
      'background-image': "url('" + this.getImgSrc() + "')",
    });
    eZoomer.show().css({
      left: this.coords.left,
      top: this.coords.top,
      width: this.coords.width,
      height: this.coords.height,
    });
  };

  this.elems.container.on('mouseover', () => {
    // mouseover
    this.updateCoords();
    
    if(!window.IS_TAP_ENABLED) {
      clearTimeout(zoomOutTimeout);
			isHover = true;
			showZoomer();
    }
  });

  eZoomer.on('mouseout', () => {
    zoomOutTimeout = setTimeout(() => {
      isHover = false;
      eZoomer.hide();
    }, zoomOutDelay);
  });

  eZoomer.on('mousemove', (e) => {
		if(!window.IS_TAP_ENABLED) {
			// MouseMove
			if(!isHover) return;
			let mouseX = Math.round(e.pageX - this.coords.left - 1);
			let mouseY = Math.round(e.pageY - this.coords.top - 1);
			let percX = parseInt(mouseX * 100 / this.coords.width);
			let percY = parseInt(mouseY * 100 / this.coords.height);
			// console.log('perc: ', percX, percY, this.zoomer.image.width / 100, this.zoomer.image.width / 100 * percX);
			eImg.css({
        position: 'relative',
				left: (this.coords.zoomWidth / 100 * percX * -1) + (this.coords.width / 2),
				top: (this.coords.zoomHeight / 100 * percY * -1) + (this.coords.height / 2),
			});
		}
  });
  // @ END OVER

  // @ START TAP
  // HammerJS
  let hCoords = {};
	let hamRoot = new Hammer.Manager(this.elems.container[0]);
	hamRoot.add(new Hammer.Tap({event: 'doubletap', taps: 2}));
	hamRoot.add(new Hammer.Tap({event: 'singletap'}));
	hamRoot.get('doubletap').recognizeWith('singletap');
	hamRoot.get('singletap').requireFailure('doubletap');
	// hamRoot.on('doubletap', ev => {
	hamRoot.on('singletap', ev => {
		console.log('doubletap!!');
		this.updateCoords();
		isTapped = !isTapped;
		if(isTapped) {
			showZoomer();
      hCoords = {
        imgX: 0,
        imgY: 0,
        mouseX: 0,
        mouseY: 0,
        minX: this.coords.zoomWidth * -1 + this.coords.width,
        minY: this.coords.zoomHeight * -1 + this.coords.height,
      };
      // console.log('coords: ', this.coords, hCoords);
		} else {
      console.log('hide!');
			eZoomer.hide();
		}
	});
	let hamImage = new Hammer(eZoomer[0]);
	hamImage.get('pan').set({direction: Hammer.DIRECTION_ALL});
	hamImage.on('panstart', ev => {
		// Salvar coordenadas
		if(!isTapped) return;
		hCoords.imgX = parseInt(eImg.css('left').replace('px', ''));
		hCoords.imgY = parseInt(eImg.css('top').replace('px', ''));
		hCoords.mouseX = ev.center.x;
		hCoords.mouseY = ev.center.y;
		// console.log('pann::: ',eImg.css('left'), hCoords);
	});
	hamImage.on('panleft panright panup pandown', ev => {
		// console.log('ev::: ', ev);
		if(!isTapped) return;
		let mouseX = ev.center.x;
		let mouseY = ev.center.y;
		let diffX = hCoords.mouseX - mouseX;
		let diffY = hCoords.mouseY - mouseY;
		let moveX = hCoords.imgX - diffX;
		let moveY = hCoords.imgY - diffY;
		console.log('moves: ', moveY, hCoords.minY);
		if(moveX > 0) moveX = 0;
		if(moveY > 0) moveY = 0;
		if(moveX < hCoords.minX) moveX = hCoords.minX;
		if(moveY < hCoords.minY) moveY = hCoords.minY;
		eImg.css({
			left: moveX,
			top: moveY,
		});
  });
  eZoomer.click(() => {
    if(isTapped) {
      isTapped = false;
      eZoomer.hide();
    }
  });
	// @ END TAP
};

InnerZoom.prototype.render = function render() {
};

export default function() {
	$(document).ready(function() {
		$('[data-inner-zoom]').each(function() {
			new InnerZoom(this);
		});
	});
};
